export enum CreateDocumentQueryAction {
    CREATE_DOCX = 'create-docx',
    CREATE_XLSX = 'create-xlsx',
}
